import React, { useState, useEffect } from "react";
import { Popover } from "antd";
import { TaskButtons } from "../buttons/TaskButtons";
import { useIntl } from "react-intl";

const LongTextCustomField = ({ field, onChange, maxLength = 300 }) => {
  const intl = useIntl();

  const [value, setValue] = useState(
    typeof field?.value === "string" ? field.value : String(field?.value || "")
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setValue(
      typeof field?.value === "string" ? field.value : String(field?.value || "")
    );  //prevent error when field type changes 
  }, [field]);

  const handleSave = () => {
    onChange(value);
    setOpen(false);
  };

  const content = (
    <div className="w-[600px]">
      <textarea
        value={value}
        onChange={(e) =>
          e.target.value.length <= maxLength && setValue(e.target.value)
        }
        placeholder={`Enter ${field?.name}`}
        rows={6}
        className="w-full h-[220px] overflow-y-scroll no-scrollbar resize-none p-2 text-sm rounded-md border border-[#D6D6D6] focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <div className="flex justify-between items-center text-xs text-gray-500">
        <span>{value.length}/{maxLength}</span>
        <div className="-mr-5">
          <TaskButtons
            className="justify-end"
            onHandle={handleSave}
            onCancel={() => setOpen(false)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      title={intl.formatMessage({ id: "ADD_TEXT", defaultMessage: "Add text" })}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
      overlayClassName="custom-field-popover"
    >
      {value ? (
        <div
          className={`flex items-center w-full cursor-pointer overflow-hidden whitespace-nowrap truncate rounded-r hover:bg-indigo-50/50 transition-colors ${
            open ? "bg-indigo-50/40" : ""
          }`}
          style={{ padding: "8px 12px", minHeight: 40 }}
        >
          <span className="truncate text-start text-[13px] line-clamp-1 overflow-hidden w-full" style={{ color: 'rgba(15,15,25,0.8)' }}>
            {value}
          </span>
        </div>
      ) : (
        <div className="flex items-center px-3 w-full cursor-pointer rounded-r hover:bg-indigo-50/50 transition-colors" style={{ minHeight: 40 }}>
          <span className="text-[13px]" style={{ color: 'rgba(15,15,25,0.28)' }}>Empty</span>
        </div>
      )}
    </Popover>
  );
};

export default LongTextCustomField;
